import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../actions/utils/axiosInstance';

export interface UsageData {
  used: number;
  limit: number | null;
  remaining: number | null;
  percentUsed: number;
  period: string;
  tier: string;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalJobs: number;
}

interface UseUsageResult {
  usage: UsageData | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
  isLimitExceeded: boolean;
}

export function useUsage(): UseUsageResult {
  const [usage, setUsage] = useState<UsageData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUsage = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await axiosInstance.get('/usage/current');
      setUsage(response.data.data);
    } catch (err) {
      setError('Failed to load usage data');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  const isLimitExceeded = usage !== null && usage.limit !== null && usage.used >= usage.limit;

  return { usage, isLoading, error, refresh: fetchUsage, isLimitExceeded };
}
